/**
 * DoD human-performance domains, synthesized from Total Force Fitness
 * (CJCSI 3405.01), Army H2F (FM 7-22), Air Force Comprehensive Airman
 * Fitness, and SOF POTFF.
 *
 * TODO(product): drive this list from the tenant's taxonomy pack instead
 * of a hardcoded constant, so each service/tenant sees its own doctrine's
 * domain names.
 */
export const HP_DOMAINS = [
  { id: 'physical', name: 'Physical' },
  { id: 'cognitive', name: 'Cognitive / Mental' },
  { id: 'psychological', name: 'Psychological / Behavioral' },
  { id: 'nutritional', name: 'Nutritional' },
  { id: 'sleep_recovery', name: 'Sleep & Recovery' },
  { id: 'spiritual', name: 'Spiritual' },
  { id: 'social_family', name: 'Social / Family' },
  { id: 'medical_dental', name: 'Medical / Dental' },
  { id: 'environmental', name: 'Environmental' },
  { id: 'financial', name: 'Financial' },
] as const;
